var _rect, _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4854 25H45.5391C47.6445 25 48.9092 23.9473 48.9092 22.2178V22.2041C48.9092 20.9189 48.0205 19.9756 46.6875 19.832V19.7158C47.6582 19.5518 48.417 18.6289 48.417 17.6035V17.5898C48.417 16.0791 47.3027 15.1357 45.4502 15.1357H41.4854V25ZM45.0947 16.3867C46.2295 16.3867 46.8926 16.9268 46.8926 17.8564V17.8701C46.8926 18.8271 46.1885 19.333 44.835 19.333H43.0166V16.3867H45.0947ZM45.1426 20.502C46.585 20.502 47.3438 21.0488 47.3438 22.1084V22.1221C47.3438 23.1816 46.6123 23.749 45.2314 23.749H43.0166V20.502H45.1426ZM52.7441 25.123C53.7285 25.123 54.5078 24.6992 54.9453 23.9473H55.0615V25H56.5312V19.9209C56.5312 18.3623 55.4785 17.4326 53.6123 17.4326C51.9238 17.4326 50.7549 18.2461 50.5771 19.4629L50.5703 19.5107H51.999L52.0059 19.4834C52.1836 18.957 52.7236 18.6562 53.5439 18.6562C54.5488 18.6562 55.0615 19.1074 55.0615 19.9209V20.5771L53.0518 20.6934C51.2812 20.8027 50.2832 21.5752 50.2832 22.9014V22.915C50.2832 24.2617 51.3291 25.123 52.7441 25.123ZM51.7598 22.8535V22.8398C51.7598 22.1699 52.2246 21.8008 53.25 21.7393L55.0615 21.623V22.2588C55.0615 23.2158 54.248 23.9404 53.1406 23.9404C52.3408 23.9404 51.7598 23.5371 51.7598 22.8535ZM61.3232 25.1436C63.0869 25.1436 64.3994 24.207 64.3994 22.833V22.8193C64.3994 21.7461 63.7158 21.1377 62.2871 20.8027L61.1113 20.5361C60.2773 20.3379 59.9355 20.0508 59.9355 19.5859V19.5723C59.9355 18.9775 60.5234 18.5742 61.3369 18.5742C62.1709 18.5742 62.6973 18.9639 62.8408 19.4834V19.4971H64.2559V19.4902C64.126 18.2803 63.0391 17.4326 61.3438 17.4326C59.6621 17.4326 58.459 18.3623 58.459 19.6543V19.6611C58.459 20.748 59.1084 21.3838 60.5098 21.7051L61.6924 21.9785C62.5537 22.1768 62.9023 22.4912 62.9023 22.9561V22.9697C62.9023 23.5781 62.2666 23.9951 61.3506 23.9951C60.4688 23.9951 59.9287 23.6191 59.7441 23.0586L59.7373 23.0518H58.2539V23.0586C58.3975 24.3027 59.5322 25.1436 61.3232 25.1436ZM66.9424 16.25C67.4482 16.25 67.8721 15.833 67.8721 15.3271C67.8721 14.8145 67.4482 14.3975 66.9424 14.3975C66.4297 14.3975 66.0127 14.8145 66.0127 15.3271C66.0127 15.833 66.4297 16.25 66.9424 16.25ZM66.1973 25H67.6738V17.5762H66.1973V25ZM72.958 25.1436C74.7969 25.1436 75.8564 24.1523 76.123 22.71L76.1367 22.6484H74.7148L74.7012 22.6826C74.4619 23.4824 73.8877 23.9062 72.958 23.9062C71.7344 23.9062 70.9756 22.9082 70.9756 21.2676V21.2539C70.9756 19.6543 71.7207 18.6699 72.958 18.6699C73.9424 18.6699 74.5439 19.2168 74.708 19.9482L74.7148 19.9688L76.1367 19.9619V19.9277C75.9316 18.4854 74.8174 17.4326 72.9512 17.4326C70.7842 17.4326 69.4648 18.9023 69.4648 21.2539V21.2676C69.4648 23.667 70.791 25.1436 72.958 25.1436Z",
    fill: "#212121"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2754_3145)",
    filter: "url(#filter0_i_2754_3145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5721 18.2695L22.0321 17.7555L20.4481 14.5475C20.4023 14.4689 20.3366 14.4036 20.2576 14.3583C20.1787 14.3129 20.0892 14.2891 19.9981 14.2891C19.9071 14.2891 19.8176 14.3129 19.7387 14.3583C19.6597 14.4036 19.594 14.4689 19.5481 14.5475L17.9681 17.7555L14.4281 18.2695C14.3358 18.2829 14.249 18.3219 14.1777 18.382C14.1064 18.4422 14.0533 18.5211 14.0244 18.6099C13.9956 18.6986 13.9922 18.7937 14.0146 18.8843C14.037 18.9749 14.0843 19.0574 14.1511 19.1225L16.7131 21.6225L16.1071 25.1485C16.0913 25.2405 16.1016 25.3351 16.1368 25.4216C16.1719 25.5081 16.2306 25.583 16.3062 25.6379C16.3818 25.6927 16.4712 25.7253 16.5643 25.732C16.6574 25.7386 16.7506 25.719 16.8331 25.6755L20.0001 24.0075L23.1671 25.6725C23.2386 25.7104 23.3183 25.73 23.3991 25.7295C23.472 25.7297 23.544 25.7139 23.6102 25.6833C23.6763 25.6527 23.7349 25.608 23.782 25.5524C23.8291 25.4968 23.8634 25.4315 23.8826 25.3612C23.9018 25.291 23.9054 25.2173 23.8931 25.1455L23.2871 21.6195L25.8491 19.1195C25.916 19.0544 25.9633 18.9719 25.9857 18.8813C26.0081 18.7907 26.0047 18.6956 25.9758 18.6069C25.947 18.5181 25.8939 18.4392 25.8226 18.379C25.7512 18.3189 25.6645 18.2799 25.5721 18.2665V18.2695Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2754_3145",
    x: 14,
    y: 14,
    width: 12,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2754_3145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2754_3145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicIcon);
export default __webpack_public_path__ + "static/media/basic-icon.b042bb93ae675ad522f1127e7f851a38.svg";
export { ForwardRef as ReactComponent };